import styled from 'styled-components';

export const CguViewWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 50px;
  h2, a {
    color: ${props => `${props.theme.color.primaryColor}`};
  }
`;
